import { createContext, use, type ReactNode } from "react";

export type PersonProfileTab = "overview" | "timeline" | "good-vibes" | "feedback" | "reviews" | "goals";

const PersonProfileTabContext = createContext<PersonProfileTab>("overview");

export function usePersonProfileTab() {
    return use(PersonProfileTabContext);
}

export interface PersonProfileTabProviderProps {
    tab: PersonProfileTab;
    children: ReactNode;
}

export function PersonProfileTabProvider({ tab, children }: PersonProfileTabProviderProps) {
    return <PersonProfileTabContext value={tab}>{children}</PersonProfileTabContext>;
}
